import GET_WEBSITES from '@/graphql/Website/getWebsite.gql';
import GET_WEBSITE_BY_ID from '@/graphql/Website/getWebsiteById.gql';
import DELETE_WEBSITE from '@/graphql/Website/deleteWebsite.gql';
import CREATE_WEBSITE from '@/graphql/Website/createWebsite.gql';
import UPDATE_WEBSITE from '@/graphql/Website/updateWebsite.gql';
import DISCONNECT_INTEGRATION from '@/graphql/Website/disconnectIntegration.gql';
import TOGGLE_WEBSITE_DEPRECATED_STATUS from '@/graphql/Website/PlanOptions/toggleWebsiteDeprecatedStatus.gql';
import TOGGLE_BA_DEPRECATED_STATUS from '@/graphql/Website/PlanOptions/toggleBingAdsDeprecatedStatus.gql';
import TOGGLE_GA_DEPRECATED_STATUS from '@/graphql/Website/PlanOptions/toggleGoogleAnalyticsDeprecatedStatus.gql';
import TOGGLE_MEDIA_DEPRECATED_STATUS from '@/graphql/Website/PlanOptions/toggleMediaDeprecatedStatus.gql';
import GET_USER from '@/graphql/User/getUser.gql';
import { authClient, axios, graphClient } from '../main'

export default class WebsiteResource {
    async get () {
        return await authClient.query({
            query: GET_WEBSITES,
            update: data => data.me.websites
        })
    }

    async getById (id) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: GET_WEBSITE_BY_ID,
            variables: {
                websiteId: id
            }
        })
    }

    async delete (id) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: DELETE_WEBSITE,
            variables: {
                id: id
            }
        })
    }

    async update (website) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_WEBSITE,
            variables: {
                websiteId: website.id,
                currencyId: website.currency.id,
                websiteName: website.domain
            }
        })
    }

    async create (name, currency) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CREATE_WEBSITE,
            variables: {
                name: name,
                currency: currency
            }
        })
    }

    async disconnectIntegration (websiteId, integration) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: DISCONNECT_INTEGRATION,
            variables: {
                websiteId: websiteId,
                integration: integration
            }
        })
    }

    async toggleDeprecatedStatus (websiteId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: TOGGLE_WEBSITE_DEPRECATED_STATUS,
            variables: {
                websiteId: websiteId
            }
        })
    }

    async toggleBingAdsDeprecatedStatus (websiteId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: TOGGLE_BA_DEPRECATED_STATUS,
            variables: {
                websiteId: websiteId
            }
        })
    }

    async toggleGoogleAnalyticsDeprecatedStatus (websiteId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: TOGGLE_GA_DEPRECATED_STATUS,
            variables: {
                websiteId: websiteId
            }
        })
    }

    async toggleMediaDeprecatedStatus (websiteId, accountId) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: TOGGLE_MEDIA_DEPRECATED_STATUS,
            variables: {
                websiteId: websiteId,
                accountId: accountId
            },
            update: (proxy, { data: { toggleMediaDeprecatedStatus } }) => {
                const data = proxy.readQuery({ query: GET_USER });
                data.me.medias = toggleMediaDeprecatedStatus.medias;
                proxy.writeQuery({ query: GET_USER, data });
            }
        })
    }
}
